import React, { useContext } from "react";
import styled from "styled-components";

import { Cartesian } from "@examspark/types";

import { Text } from "../cartesian/Text";
import { useCartesianDrag } from "../cartesian/useDrag";
import {
  CartesianGraphContext,
  getImageCoordsFromCartesianCoords,
} from "../cartesian/utils";

const Point = styled.circle`
  fill: #5bade4;
  transition: fill 0.2s;
`;
const DragRegion = styled.circle`
  fill: yellow;
  opacity: 0;
  cursor: grab;
`;
const Group = styled.g`
  &:hover {
    ${Point} {
      fill: #539ed1;
    }
  }
`;

interface Props {
  position: number;
  label?: string;
  value: number;
  /** Fires for each pixel the object is dragged. */
  onDrag?: (coord: Cartesian.Coordinate) => void;
  /** Fires when user has released object */
  onDragEnd?: (coord: Cartesian.Coordinate) => void;
  /** Final event to fire after a drag has completed and user has released
   * object. This changes the dragged object's base position and resets the
   * offset position.*/
  onChange?: (coord: Cartesian.Coordinate) => void;
}

const Bar = styled.rect`
  fill: #5bade4;
  transition: fill 0.2s;
`;

const LineChartPoint: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const graph = useContext(CartesianGraphContext);
  const drag = useCartesianDrag(
    graph?.canvas || null,
    { x: props.position, y: props.value },
    {
      snapToGrid: true,
      restrictDragAxis: "y",
      onDragEnd: (c: Cartesian.Coordinate) => {
        // console.log("drag end!");
        props.onChange?.(c);
      },
      onDrag: (c: Cartesian.Coordinate) => {
        // console.log("drag start...", c);
        props.onDrag?.(c);
      },
    },
  );

  const pointRadius = 5;
  const pos = getImageCoordsFromCartesianCoords(graph!.graph, drag.coord);
  const posLabel = getImageCoordsFromCartesianCoords(
    graph!.graph,
    {
      ...drag.coord,
      y: 0,
    },
    {
      x: 0,
      y: 20,
    },
  );

  return (
    <Group>
      <Point r={pointRadius} cx={pos.x} cy={pos.y} />
      <DragRegion
        r={pointRadius * 3}
        cx={pos.x}
        cy={pos.y}
        onMouseDown={(e) => {
          drag?.startDrag?.(e);
          // props.onDragStart?.();
        }}
        onMouseUp={(e) => {
          drag?.stopDrag?.(e);
        }}
      />
      {props.label && (
        <Text coords={posLabel} anchor="middle">
          {props.label}
        </Text>
      )}
    </Group>
  );
};

export default LineChartPoint;
